import { MerchantKnowledgeSuggestionStatus } from "@redotech/crdb-enums/agent-knowledge/merchant-knowledge-suggestion-status";
import { merchantKnowledgeSuggestionListItemSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import * as z from "zod";

/**
 * Suggestion list, most-justified first. Omit `statuses` for the pending
 * review queue.
 */
export const listSuggestedKnowledge = {
  name: "listSuggestedKnowledge" as const,
  input: z.object({
    /** Present switches to index-backed search; absent browses the table. */
    query: z.string().optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
    statuses: z.array(z.enum(MerchantKnowledgeSuggestionStatus)).optional(),
  }),
  output: z.object({
    suggestions: z.array(merchantKnowledgeSuggestionListItemSchema),
    totalCount: z.number(),
  }),
};
